/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { CreateOneBaseAodRulesControllerAodRuleMutationRequest, CreateOneBaseAodRulesControllerAodRuleMutationResponse } from "../models/CreateOneBaseAodRulesControllerAodRule";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { createOneBaseAodRulesControllerAodRule } from "../axios/createOneBaseAodRulesControllerAodRule";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const createOneBaseAodRulesControllerAodRuleMutationKey = () => ["audit-reports-api", { url: '/aod-rules' }] as const

export type CreateOneBaseAodRulesControllerAodRuleMutationKey = ReturnType<typeof createOneBaseAodRulesControllerAodRuleMutationKey>

export function createOneBaseAodRulesControllerAodRuleMutationOptions<TContext = unknown>(config: Partial<RequestConfig<CreateOneBaseAodRulesControllerAodRuleMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = createOneBaseAodRulesControllerAodRuleMutationKey()
        return mutationOptions<CreateOneBaseAodRulesControllerAodRuleMutationResponse, ResponseErrorConfig<Error>, {data: CreateOneBaseAodRulesControllerAodRuleMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return createOneBaseAodRulesControllerAodRule(data, config)
          },
        })

}

/**
 * @summary Create a single AodRule
 * {@link /aod-rules}
 */
export function useCreateOneBaseAodRulesControllerAodRule<TContext>(options: 
{
  mutation?: UseMutationOptions<CreateOneBaseAodRulesControllerAodRuleMutationResponse, ResponseErrorConfig<Error>, {data: CreateOneBaseAodRulesControllerAodRuleMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<CreateOneBaseAodRulesControllerAodRuleMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? createOneBaseAodRulesControllerAodRuleMutationKey()

          const baseOptions = createOneBaseAodRulesControllerAodRuleMutationOptions(config) as UseMutationOptions<CreateOneBaseAodRulesControllerAodRuleMutationResponse, ResponseErrorConfig<Error>, {data: CreateOneBaseAodRulesControllerAodRuleMutationRequest}, TContext>
          

          return useMutation<CreateOneBaseAodRulesControllerAodRuleMutationResponse, ResponseErrorConfig<Error>, {data: CreateOneBaseAodRulesControllerAodRuleMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<CreateOneBaseAodRulesControllerAodRuleMutationResponse, ResponseErrorConfig<Error>, {data: CreateOneBaseAodRulesControllerAodRuleMutationRequest}, TContext>
      
}